import { Component, Input, OnChanges } from '@angular/core';
import { ColumnDef, StatusVariant } from '../../../shared/data-table/data-table.model';
import { AttendanceReportRow } from '../../../_models/reports/attendance-report-row.model';

@Component({
    selector: 'attendance-report',
    templateUrl: 'attendance-report.component.html',
    styleUrls: ['attendance-report.component.css'],
    standalone: false
})
export class AttendanceReportComponent implements OnChanges {

    @Input() rows: AttendanceReportRow[];

    public tableRows: AttendanceReportRow[] = [];

    public columns: ColumnDef<AttendanceReportRow>[] = [
        { field: 'studentName', header: 'Learner', type: 'template', sortable: true },
        { field: 'clientName', header: 'Client', sortable: true },
        { field: 'tutor', header: 'Tutor', sortable: true },
        { field: 'subject', header: 'Subject', sortable: true },
        { field: 'sessionDelivery', header: 'Delivery', sortable: true },
        { field: 'startDate', header: 'Date', type: 'date', sortable: true },
        { field: 'startTime', header: 'Start', type: 'template' },
        { field: 'endTime', header: 'End', type: 'template' },
        { field: 'attendance', header: 'Attendance', type: 'pill', sortable: true, pillMap: row => this.attendancePill(row) },
        { field: 'reason', header: 'Reason', type: 'template' },
        { field: 'engagement', header: 'Engagement', sortable: true },
        { field: 'comprehension', header: 'Comprehension', sortable: true },
        // Report status (Submitted / Approved / Rejected) — a template column so it uses the same
        // app-session-status-pill as the session tiles, not the attendance colour map above.
        { field: 'status', header: 'Status', type: 'template', sortable: true }
    ];

    ngOnChanges(): void {
        const source = this.rows != null ? this.rows : [];
        // Derive a sortable studentName (last name first, matching the previous sort accessor).
        this.tableRows = source.map(row => ({
            ...row,
            studentName: (row.studentLastName + ' ' + row.studentFirstName).trim().toLowerCase()
        }));
    }

    private attendancePill(row: AttendanceReportRow): StatusVariant {
        const attendance = (row.attendance || '').toLowerCase();
        if (attendance.includes('present') || attendance.includes('attended')) { return 'green'; }
        if (attendance.includes('late')) { return 'amber'; }
        if (attendance.includes('absent') || attendance.includes('dna')) { return 'red'; }
        return 'gray';
    }
}
